import NextImage from 'components/NextImage/NextImage';
import { ProductType } from 'frontend/enums';
import { Image, ProductVersion, ProductVersionName, Program, Relations, Series } from 'frontend/types';
import React from 'react';
import ProductRelations from '../../../ProductRelations/ProductRelations';
import ToggleButton from '../ToggleButton/ToggleButton';
import styles from './Open.module.css';
interface OpenProps {
  description: string;
  educationLevels: string;
  images: Image;
  isSeriesPage: boolean;
  schoolSubjects?: string;
  title: string;
  toggle: () => void;
  version: ProductVersionName | null;
  allVersions: ProductVersion[];
  relations: Relations | null;
}
const Open = ({
  description,
  educationLevels,
  images,
  isSeriesPage,
  schoolSubjects,
  title,
  toggle,
  version,
  allVersions,
  relations
}: OpenProps, ref: React.Ref<HTMLButtonElement>) => {
  const showProductRelations = Boolean(version && allVersions || relations?.variants);
  return <>
      <div className={styles.seriesBannerHeader}>
        <ToggleButton isOpen toggle={toggle} ref={ref} data-sentry-element="ToggleButton" data-sentry-source-file="Open.tsx" />
      </div>
      <div className={styles.contentWrapper}>
        <div className={styles.contentLeft}>
          <figure className={styles.imageWrapper}>
            <NextImage width={320} height={180} src={images['640x360']} alt="seriebild" roundedCorners shadow data-sentry-element="NextImage" data-sentry-source-file="Open.tsx" />
          </figure>
          <div className={styles.metadata}>
            {educationLevels && <p className={styles.metadataValues}>{`• ${educationLevels}`}</p>}
            {schoolSubjects && <p className={styles.metadataValues}>{`• ${schoolSubjects}`}</p>}
          </div>
        </div>
        <div className={styles.contentRight}>
          <div className={styles.productDescription}>
            {isSeriesPage ? <h1 className={styles.seriesTitle}>{title}</h1> : <h2 className={styles.seriesTitle}>{title}</h2>}
            <p className={styles.description}>{description}</p>
          </div>
          {showProductRelations && <ProductRelations leadingText="Serien finns även" dataTrk="series_banner" isSeriesPage={isSeriesPage} currentProduct={{
          version,
          allVersions,
          relations,
          productType: ProductType.SERIES
        } as Program | Series} />}
        </div>
      </div>
    </>;
};
export default React.forwardRef(Open);